var _rect, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCertificate(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 118,
    height: 119,
    viewBox: "0 0 118 119",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 118,
    height: 119,
    fill: "url(#pattern0_3620_54)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_3620_54",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_3620_54",
    transform: "matrix(0.00672316 0 0 0.00666667 -0.00423729 0)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_3620_54",
    width: 150,
    height: 150,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAJYAAACWCAMAAAAL34HQAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAzUExURQAAAGDPIGjHIGXKJWTLJGbJI2XKI2bLImbLImbLJGfMI2bMI2XLI2bLImbMI2bLI2bLI1hoHY8AAAAQdFJOUwAQIDBAUGBwf4+fr7/P3+8FUYRsAAAACXBIWXMAABcRAAAXEQHKJvM/AAACnElEQVR4Xu3bbZuiIBiGYVGQV2P//69drGcTFUvAiebY+/w2VnqNmgnTdAAAAAAAAAAAANlG19BIEXvqT0OKIvaQtYesHMjK8XuzvPkY2uKprBst+IAbbRJZZyArB7Jy/E9ZbBiEVFprY61z1hqjlVIj7+nx9y7NYqFGu8nT81Nu1qgTeVdlMa5e96zdrOKMXppyQda9iJ6SxYc2WsdWZVZIythHKem0miwmXV3SP1ZuD2hxFlNFB+6IW2+/MIvpa/ZTLB6pFmY9l11J0sqDsix+/b6aLdezsqwf2Vnx7irLsrTkgJ+s1VKOQnA+DFwIMY5KGffc2AFLqy/NcrRkyzsj+fDq8t3PH09Hp4ChJ5VmaVoSmd58nKwJaRO7bmkoy2K05ME7nVG0EGq9133tKd9JWhT2kn550N4R0VVZ07KgMKvj8wLv5EA/V2Dy/g7y0WWrOCv8nmPVbloT4/o0KM/6UcjKgawcyMqBrBzIyoGsBDPfgDC7nyppmhXuJkWoikdipCzL0N9Gz6CXpMw3kyoUePp5UZZ1NMRIoZdssPnW/7maYZBa0CN3rbK63ejnO7J2q1id982ydmM6Wv7QKosvfwR78KuvFpRlhaH7afSSWJ+eG9PLMKosqxJLz9j55axvktWx5CxE9fxWtYFWGYsG1a2y+ud2F9eMqmss1/dYNBNeltXz8+glsfDpnOJr34mV161+e9F6cLWTlPWXU7k9ubyKJ39aZUUzZA/rm5tmWbvT6zs+qrcHMX4ftstik1F82fio1t8CLMu6yHxzM/+Gfjet2DQrDDFUN/jEtptmddN85Nj0ZQOy7nBOuG3WIWTlQFaOnKwPfmXxea9/IqsFZOVAVg5k5fh1WV/6DzUAAAAAAAAAAABpXfcXQMNXIKIDWZoAAAAASUVORK5CYII="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCertificate);
export default __webpack_public_path__ + "static/media/certificate.697644b4818fc4b40144bd85a7db1f57.svg";
export { ForwardRef as ReactComponent };